import { Link } from 'react-router';
import { Button, Card } from '../../components/ui';
import { useNetwork } from '../../stores/network';
import { useConnections, useStravaConnect } from './strava-hooks';
import { useT } from '../../i18n';

/** Strava on the home screen: the official connect button, or the connection status. */
export function HomeStravaCard() {
  const q = useConnections();
  const connect = useStravaConnect();
  const online = useNetwork((s) => s.online);
  const t = useT();
  const strava = q.data?.find((c) => c.provider === 'STRAVA');
  if (!strava?.available) return null;

  return (
    <Card className="mt-4" >
      <div data-testid="home-strava">
        {strava.connected ? (
          <div className="flex items-center gap-3">
            <div className="min-w-0 flex-1">
              <div className="font-semibold">{t('Strava connected')}</div>
              <div className="text-xs text-ink-400">
                {t(strava.autoImport ? 'New runs from your watch are imported automatically.' : 'Auto-import is off — import runs manually.')}
              </div>
            </div>
            <Link to="/imports/strava">
              <Button size="sm" variant="secondary">
                {t('Import')}
              </Button>
            </Link>
          </div>
        ) : (
          <>
            <div className="font-semibold">{t('Running with a watch?')}</div>
            <div className="mt-0.5 text-xs text-ink-400">
              {t('Connect Strava to bring your COROS, Garmin, Suunto or Apple Watch runs into the game.')}
            </div>
            <button
              onClick={() => connect.mutate()}
              disabled={!online || connect.isPending}
              aria-label="Connect with Strava"
              className="mt-3 disabled:opacity-50"
              data-testid="home-strava-connect"
            >
              <img src="/brand/strava/btn_strava_connect_with_orange.svg" alt="Connect with Strava" className="h-12 w-auto" />
            </button>
          </>
        )}
        <img src="/brand/strava/api_logo_pwrdBy_strava_horiz_white.svg" alt="Powered by Strava" className="mt-3 h-3.5" />
      </div>
    </Card>
  );
}
